const Language = {
    en: "en",
    he: "he",
    ar: "ar"
}
  
export default Language
  